import GlobalIcon from "../GlobalIcon/GlobalIcon";
import styles from "./ToggleSwitch.module.css";

/**
 * Toggle switch: pill track, circular thumb with X (off) / check (on).
 * Props: checked (bool), onChange (function called with new value), aria-label (string).
 */
function ToggleSwitch({ checked, onChange, "aria-label": ariaLabel, className }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      className={`${styles.root} ${checked ? styles.checked : ""} ${className ?? ""}`.trim()}
      onClick={() => onChange(!checked)}
    >
      <span className={styles.track}>
        <span className={styles.thumb}>
          {checked ? (
            <GlobalIcon iconName="ToggleOnIcon" className={styles.icon} aria-hidden />
          ) : (
            <GlobalIcon iconName="ToggleOffIcon" className={styles.icon} aria-hidden />
          )}
        </span>
      </span>
    </button>
  );
}

export default ToggleSwitch;
